export default __webpack_public_path__ + "static/media/1.4276ab9e.png";